import { render, staticRenderFns } from "./CoursesHeader.vue?vue&type=template&id=7cd3a9ee&"
import script from "./CoursesHeader.vue?vue&type=script&lang=js&"
export * from "./CoursesHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports